/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import './component002.less';

interface IComponent002Props {
  icon1?: string;
  title1?: string;
  title2?: string;
  title3?: string;
  canDoItems: string[];
  cannotDoItems: string[];
  thirdItems: string[];
  className?: string;
}

const Component002: React.FunctionComponent<IComponent002Props> = ({
  icon1,
  title1,
  title2,
  title3,
  canDoItems,
  cannotDoItems,
  thirdItems,
  className,
}) => (
  <>
    <div className={`component002 ${className}`}>
      <div className="cando-img">
        <img src={require(`../../../../../assets/${icon1}`).default} alt="" />
      </div>
      <div className="cando-section">
        <div className="can-do">
          <div className="cando-title" style={{ backgroundColor: '#5384CC' }}>
            {title1}
          </div>
          <div className="cando-body">
            <div className="cando-content">
              <ul>
                {canDoItems.map((itm: string) => (
                  <li key={itm}>{itm}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="can-not-do">
          <div className="cando-title" style={{ backgroundColor: '#5384CC' }}>
            {title2}
          </div>
          <div className="cando-body">
            <div className="cando-content">
              <ul>
                {cannotDoItems.map((itm: string) => (
                  <li key={itm}>{itm}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="can-not-do">
          <div className="cando-title" style={{ backgroundColor: '#5384CC' }}>
            {title3}
          </div>
          <div className="cando-body">
            <div className="cando-content">
              <ul>
                {thirdItems.map((itm: string) => (
                  <li key={itm}>{itm}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);
export default Component002;
